export default "__VITE_ASSET__9c8db384__"